import { useCallback } from 'react';

import { Alert } from '~/components/alert';
import { AuthContextType, useAuth } from '~/contexts/auth';
import { useIntl } from '~/contexts/intl';

export type SignOutProps = {
    biometric: AuthContextType['biometric'];
    remote: AuthContextType['remote'];
    logoutFailure: string;
};

export async function profileSignOut(props: SignOutProps) {
    if (props.biometric.enabled) {
        await props.biometric.disable();
    }
    const result = await props.remote.logout();
    if (result.success) {
        result.commit();
    } else {
        Alert.alert(props.logoutFailure);
    }
}

export function useSignOut() {
    const { biometric, remote } = useAuth();
    const { formatMessage } = useIntl();

    return useCallback(async () => {
        await profileSignOut({ biometric, remote, logoutFailure: formatMessage('auth-logout.failure') });
    }, [biometric, remote, formatMessage]);
}
